import { render, staticRenderFns } from "./docs-per-month-bar.vue?vue&type=template&id=0cfa07a4&"
import script from "./docs-per-month-bar.vue?vue&type=script&lang=js&"
export * from "./docs-per-month-bar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports